import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import './insurance.scss';
import AOS from "aos";
import "aos/dist/aos.css";

export default function CPGummary() {

  useEffect(() => {
    AOS.init({
      once: true
    });
    AOS.refresh();
  }, []);

  return (
  
    <>
      <h5>Insurance Industry Summary</h5>

      <ul className="financial-listing">
        <li>Insurance companies typically use mail to <span data-aos className='highlighter highlighter-summary'>drive loyalty.</span></li>
        <li>Businesses in the insurance sector are the <span data-aos className='highlighter highlighter-summary'>most likely to use letters in direct mail campaigns.</span></li>
        <li>Out of all direct mail techniques, insurance companies <span data-aos className='highlighter highlighter-summary'>most often use personalized greetings or customer names.</span></li>
        <li>Insurance businesses typically <span data-aos className='highlighter highlighter-summary'>measure the impact of direct mail via response rates.</span></li>
      </ul>
    </>
  );
}
